export const healthFilterOptions = [
  'alcohol-cocktail',
  'alcohol-free',
  'celery-free',
  'crustcean-free',
  'dairy-free',
  'egg-free',
  'DASH',
  'fish-free',
  'fodmap-free',
  'gluten-free',
  'immuno-supportive',
  'keto-friendly',
  'kidney-friendly',
  'kosher',
  'low-potassium',
  'low-sugar',
  'lupine-free',
  'Mediterranean',
  'mollusk-free	',
  'mustard-free',
  'no-oil-added	',
  'paleo',
  'peanut-free',
  'pescatarian',
  'pork-free',
  'red-meat-free',
  'sesame-free',
  'shellfish-free',
  'soy-free',
  'sugar-conscious',
  'sulfite-free',
  'tree-nut-free',
  'vegan',
  'vegetarian',
  'wheat-free'
]

export const mealTypes = [
  'Breakfast',
  'Brunch',
  'Lunch',
  'Dinner',
  'Snack',
  'Teatime'
]

export const cuisineOptions = [
  'American',
  'Asian',
  'British',
  'Caribbean',
  'Central Europe',
  'Chinese',
  'Eastern Europe',
  'French',
  'Greek',
  'Indian',
  'Italian',
  'Japanese',
  'Korean',
  'Kosher',
  'Mediterranean',
  'Mexican',
  'Middle Eastern',
  'Nordic',
  'South American',
  'South East Asian',
  'World'
]

export const dishOptions = [
  'alcohol cocktail',
  'biscuits and cookies',
  'bread',
  'cereals',
  'condiments and sauces',
  'desserts',
  'drinks',
  'egg',
  'ice cream and custard',
  'main course',
  'pancake',
  'pasta',
  'pastry',
  'pies and tarts',
  'pizza',
  'preps',
  'preserve',
  'salad',
  'sandwiches',
  'seafood',
  'side dish',
  'soup',
  'special occasions',
  'starter',
  'sweets'
]

export const nutrients = [
  {
    backend: 'CA',
    user: 'Calium',
    unit: 'mg'
  },
  {
    backend: 'CHOCDF',
    user: 'Carbohydrate',
    unit: 'g'
  },
  {
    backend: 'CHOCDF.net',
    user: 'Carbohydrates (net)',
    unit: 'g'
  },
  {
    backend: 'CHOLE',
    user: 'Cholesterol',
    unit: 'mg'
  },
  {
    backend: 'ENERC_KCAL',
    user: 'Energy',
    unit: 'kcal'
  },
  {
    backend: 'FAMS',
    user: 'Fatty acids, total monounsaturated',
    unit: 'g'
  },
  {
    backend: 'FAPU',
    user: 'Fatty acids, total polyunsaturated',
    unit: 'g'
  },
  {
    backend: 'FASAT',
    user: 'Fatty acids, total saturated',
    unit: 'g'
  },
  {
    backend: 'FAT',
    user: 'Total lipid (fat)',
    unit: 'g'
  },
  {
    backend: 'FATRN',
    user: 'Fatty acids, total trans',
    unit: 'g'
  },
  {
    backend: 'FE',
    user: 'Iron, Fe',
    unit: 'mg'
  },
  {
    backend: 'FIBTG',
    user: 'Fiber, total dietary',
    unit: 'g'
  },
  {
    backend: 'FOLAC',
    user: 'Folic acid',
    unit: 'µg'
  },
  {
    backend: 'FOLDFE',
    user: 'Folate, DFE',
    unit: 'µg'
  },
  {
    backend: 'FOLFD',
    user: 'Folate (food)',
    unit: 'µg'
  },
  {
    backend: 'K',
    user: 'Potassium, K',
    unit: 'mg'
  },
  {
    backend: 'MG',
    user: 'Magnesium',
    unit: 'mg'
  },
  {
    backend: 'NA',
    user: 'Sodium, Na',
    unit: 'mg'
  },
  {
    backend: 'NIA',
    user: 'Niacin',
    unit: 'mg'
  },
  {
    backend: 'P',
    user: 'Phosphorus, P',
    unit: 'mg'
  },
  {
    backend: 'PROCNT',
    user: 'Protein',
    unit: 'g'
  },
  {
    backend: 'RIBF',
    user: 'Riboflavin',
    unit: 'mg'
  },
  {
    backend: 'SUGAR',
    user: 'Sugars, total',
    unit: 'g'
  },
  {
    backend: 'SUGAR.added',
    user: 'Sugars, added',
    unit: 'g'
  },
  {
    backend: 'Sugar.alcohol',
    user: 'Sugar alcohols',
    unit: 'g'
  },
  {
    backend: 'THIA',
    user: 'Thiamin',
    unit: 'mg'
  },
  {
    backend: 'TOCPHA',
    user: 'Vitamin E (alpha-tocopherol)',
    unit: 'mg'
  },
  {
    backend: 'VITA_RAE',
    user: 'Vitamin A, RAE',
    unit: 'µg'
  },
  {
    backend: 'VITB12',
    user: 'Vitamin B12',
    unit: 'µg'
  },
  {
    backend: 'VITB6A',
    user: 'Vitamin B6',
    unit: 'mg'
  },
  {
    backend: 'VITC',
    user: 'Vitamin C',
    unit: 'mg'
  },
  {
    backend: 'VITD',
    user: 'Vitamin D (D2 + D3)',
    unit: 'µg'
  },
  {
    backend: 'VITK1',
    user: 'Vitamin K (phylloquinone)',
    unit: 'µg'
  },
  {
    backend: 'WATER',
    user: 'Water',
    unit: 'g'
  },
  {
    backend: 'ZN',
    user: 'Zinc, Zn',
    unit: 'mg'
  },
]


